import React from 'react';
import Link from 'gatsby-link';

import './_contentblock.scss';

const ContentBlock = ({children, title, subtitle, link='' }) => (
  <main className={'content-block'}>
    {subtitle? <h2 className="normal featured">{subtitle}</h2>:''}
    {title?<h1 className="huge dark">{title}</h1>:''}
    <p>
      {children}
    </p>
    {link?<Link to={link} className="featured">Mehr dazu</Link>:''}
  </main>
);

export default ContentBlock;



// WEBPACK FOOTER //
// ./src/components/contentblock/index.jsx